import { useMutation } from 'react-query'
import { useState } from 'react'
import { postProfileAdvisor, putProfileAdvisor } from 'api'
import { showErrorMessage, showSuccessMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'
import { useNavigate } from 'react-router-dom'
import useAuth from './useAuth'

const useAdvisor = () => {
  const [dataProfileAdvisor, setDataProfileAdvisor] = useState({})
  const [isSuccessSubmit, setIsSuccessSubmit] = useState(false)
  const navigate = useNavigate()
  const { userProfile } = useAuth()
  
  const isUserAdvisor = userProfile?.roles?.[0]?.code === 'ADVISOR'

  const navigateToProfileAdvisor = () => {
    navigate('/profile/advisor-information')
  }

  const isProfileAdvisorNotFilled = () => {
    const isProfileAdvisorFilled = userProfile?.is_completed_flag
    return isUserAdvisor && !isProfileAdvisorFilled
  }

  const postProfileAdvisorMutation = useMutation({
    mutationKey: 'postProfileAdvisorMutation',
    mutationFn: (payload) => postProfileAdvisor(payload),
    onSuccess: ({ data }) => {
      setDataProfileAdvisor(data)
      showSuccessMessage('Profil Advisor berhasil disimpan')
      setIsSuccessSubmit(true)
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })

  const putProfileAdvisorMutation = useMutation({
    mutationKey: 'postProfileAdvisorMutation',
    mutationFn: (payload) => putProfileAdvisor(payload),
    onSuccess: ({ data }) => {
      setDataProfileAdvisor(data)
      showSuccessMessage('Profil Advisor berhasil disimpan')
      setIsSuccessSubmit(true)
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })

  const handleSubmitProfileAdvisor = (data) => {
    postProfileAdvisorMutation.mutate(data)
  }

  const handleSubmitEditProfileAdvisor = (data) => {
    putProfileAdvisorMutation.mutate(data)
  }

  return {
    handleSubmitProfileAdvisor,
    handleSubmitEditProfileAdvisor,
    dataProfileAdvisor,
    isSuccessSubmit,
    isLoading: postProfileAdvisorMutation.isLoading,
    userProfile,
    navigateToProfileAdvisor,
    isProfileAdvisorNotFilled,
    isUserAdvisor
  }
}

export default useAdvisor
